// @flow

//Scrolls to the first form field with an error
export function scrollToError() {
  /*Not able to use destructuring here because IE 11 gives this error ‘Invalid attempt to destructure non-iterable instance’. 
  It could properly be fixed by adding the right polyfill.*/
  const errorElement = document.querySelectorAll('div[data-error^="true"]')[0];
  if (errorElement) {
    const isScrollBehaviorSupported =
      document.documentElement &&
      'scrollBehavior' in document.documentElement.style;

    if (isScrollBehaviorSupported) {
      errorElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      errorElement.scrollIntoView(false);
    }
  }
}
